<template>
  <div class="h-screen">
    <headerBar :title="hTitle" />
    <div class="my-4">
      <h2 class="font-bold text-xl">{{ subTitle1 }}</h2>
      <UlListCheck :ulListCheck="ulListCheck" />
      {{ note }}
    </div>
    <div class="my-4">
      <h2 class="font-bold text-xl">{{ subTitle2 }}</h2>
      <UlListCheck :ulListCheck="ulListCheck2" />

      <div class="my-4">{{ footer }}</div>
    </div>
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
import UlListCheck from "../../components/CheckList.vue";

export default {
  components: { HeaderBar, UlListCheck },
  props: ["hTitle"],
  data() {
    return {
      title: "Monetary Requirements",
      subTitle1: "A. Individual",
      subTitle2: "B. Company",
      ulTitle:
        "Accomplished Buyers Information Sheet signed by both spouses, if applicable",
      ulListCheck: [
        {
          li: "1 valid primary government issued ID (ex. TIN, UMID, Passport, SSS, Driver’s License, Postal ID)",
          img: "/icons/check.png",
        },
        {
          li: "Birth Certificate if single; Marriage Contract if married",
          img: "/icons/check.png",
        },
        {
          li: "BIR 1904 Form Verified by BIR of both spouses, if applicable",
          img: "/icons/check.png",
        },
      ],
      ulListCheck2: [
        { li: "Certificate of Incorporation", img: "/icons/check.png" },
        { li: "Certificate of Registration", img: "/icons/check.png" },
        {
          li: "Secretary Certificate / Board Resolution",
          img: "/icons/check.png",
        },
        {
          li: "Articles of Incorporation and By-Laws",
          img: "/icons/check.png",
        },
        { li: "TIN Verified of authorized signatory", img: "/icons/check.png" },
        {
          li: "2 valid government issued IDs of signatory",
          img: "/icons/check.png",
        },
      ],
      footer:
        "Once you have completed the payments and requirements, you will be contacted to schedule the signing the Deed of Absolute Sale at our head office.",
      note: "Note: All documents submitted will undergo evaluation. Further documents may be required.",
    };
  },
};
</script>







